import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=ad2be71e&lang=scss&scoped=true"

import exportComponent from "D:\\work\\project\\万禾项目\\东智\\dongzhistore\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad2be71e"]])

export default __exports__